import { useQuery } from "@tanstack/react-query";
import api from "../utils/api";

export const fetchGetStudentStatus = async (studyId) => {
  // 쿼리 파라미터가 추가된 URL로 API를 호출합니다.

  return await api.get(`/study-users/status/${studyId}`);
};

export const useGetStudentStatusQuery = (studyId) => {
  return useQuery({
    queryKey: ["student-status", studyId],

    queryFn: () => fetchGetStudentStatus(studyId),
    select: (data) => {
      return data.data.data;
    },
  });
};
